/** Describes what this insurance is. */
export enum InsuranceType {
	Travel = 'TRAVEL',
	Car = 'CAR',
}
